<!-- 二维码展示卡片 -->
<template>
  <Card v-if="qrCode">
    <div slot="custom-header" class="custom-header">
      <div class="custom-title">签约二维码</div>
      <div>
        <div>
          无法现场扫码？
          <span style="color: #2761F3; cursor: pointer;" @click="handleCopy">
            复制
          </span>
          二维码发送给司机，二维码有效期为24小时
        </div>
      </div>
    </div>
    <div style="text-align: center; margin-top: 12px;">
      <el-image
        class="qr-code"
        :src="qrCode"
        :preview-src-list="[qrCode]"
      />
      <div class="expire-time" v-if="expireTime">
        二维码有效期至: {{ expireTime }}
      </div>
    </div>
  </Card>
</template>

<script setup>
const props = defineProps({
  qrCode: {
    type: String,
    default: '',
  },
  expireTime: {
    type: String,
    default: '',
  },
  driverInfo: {
    type: Object,
    default: () => ({}),
  },
})

const emits = defineEmits(['copy'])

const handleCopy = () => {
  emits('copy', props.driverInfo)
}
</script>

<style lang="scss" scoped>
.custom-header {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .custom-title {
    line-height: 32px;
    font-size: 14px;
    font-weight: 500;
    color: rgba(0, 0, 0, .9);
  }
}

.qr-code {
  width: 160px;
  height: 160px;
}

.expire-time {
  margin-top: 10px;
  color: #666;
  font-size: 12px;
}
</style>
